import React from "react";
import "./ModalContent.css";

interface ModalContentProps {
  visible: boolean;
  children?: React.ReactNode;
}

const ModalContent: React.FC<ModalContentProps> = ({ visible, children }) => {
  if (!visible) return null;
  return (
    <>
      <div className="modal-dialog-overlay">{children}</div>
      <div className="modal-overlay"></div>
    </>
  );
};

export default ModalContent;
